import 'bootstrap/dist/css/bootstrap.css';
import notfound from '../notfoundprov.png';
import React, { Component } from 'react';
import './styles.css';

class Notfound extends Component {
  componentDidMount() {
    this.animateComponent();
  }

  componentWillUnmount() {
    this.removeAnimation();
  }

  componentDidUpdate(prevProps) {
    // If you need to perform animations on updates, you can add logic here.
  }

  animateComponent() {
    this.component.classList.add('animate');
  }

  removeAnimation() {
    this.component.classList.remove('animate');
  }

  render() {
    if(this.props.discover == true){
      return(
<div className="fadein" key={this.props.name} style={{ textAlign: 'center', marginTop: '30px', marginBottom: '20px' }}>
          {//<img
            //src={notfound}
           // alt={':('}
            //style={{ width: '12.5%', height: '12.5%' }}
         // />
        }
        <h1>:(</h1>
          <h3>Questo artista non ha mai collaborato con nessuno!</h3>
          <input
            type="submit"
            value="Riprova"
            className="btn btn-success"
            onClick={() => {
              window.location.reload();
            }}
            style={{ background: '#D9E724', borderColor: '#8b008b', color: 'black' }}
            ref={(component) => (this.component = component)}
          />
        </div>
      )
    } else {
      return (
        <div className="fadein" key={this.props.name} style={{ textAlign: 'center', marginTop: '30px', marginBottom: '20px' }}>
          {//<img
            //src={notfound}
           // alt={':('}
            //style={{ width: '12.5%', height: '12.5%' }}
         // />
        }
        <h1>:(</h1>
          <h3>These two artists never collaborated! Maybe in the future...</h3>
          <input
            type="submit"
            value="Try again"
            className="btn btn-success"
            onClick={() => {
              window.location.reload();
            }}
            style={{ background: '#D9E724', borderColor: '#8b008b', color: 'black' }}
            ref={(component) => (this.component = component)}
          />
        </div>
      );
    }
    
  }
}

export default Notfound;
